import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import findLastIndex from 'lodash/findLastIndex';
import sortBy from 'lodash/sortBy';
import classNames from 'classnames';

import SelectField from 'eventbrite_design_system/inputField/SelectField';
import {VALUES_PROP_TYPE} from 'eventbrite_design_system/inputField/constants';

import {
    OTHER_EVENTBRITE_CATEGORY,
} from '../constants';

import './dropdownFilter.scss';

export default class DropdownFilter extends PureComponent {
    static propTypes = {
        handleSelect: PropTypes.func,
        isHighlighted: PropTypes.bool,
        id: PropTypes.string,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        shouldOrderValues: PropTypes.bool,
        style: PropTypes.string,
        type: PropTypes.string.isRequired,
        values: VALUES_PROP_TYPE,
    }

    _handleSelect = (selectedItem) => {
        const {handleSelect, type} = this.props;

        if (handleSelect) {
            handleSelect(type, selectedItem);
        }
    }

    render() {
        const {
            isHighlighted,
            id,
            label,
            placeholder,
            shouldOrderValues,
            style,
            value,
            values,
        } = this.props;

        let displayValues = values.slice(0);

        if (shouldOrderValues) {
            const otherIndex = findLastIndex(displayValues, {value: OTHER_EVENTBRITE_CATEGORY});

            // findLastIndex returns -1 when the condition doesn't match any element in the array.
            // We want to order it only when the condition has at least one match.
            if (otherIndex !== -1) {
                const [otherCategory] = displayValues.splice(otherIndex, 1);

                displayValues = sortBy(displayValues, 'display');
                displayValues.push(otherCategory);
            } else {
                displayValues = sortBy(displayValues, 'display');
            }
        }

        const focusDropdownClass = classNames({
            'dropdown-focus': isHighlighted,
        });

        return (
            <div className={focusDropdownClass} data-spec="dropdown-filter">
                <SelectField
                    id={id}
                    label={label}
                    onChange={this._handleSelect}
                    placeholder={placeholder}
                    value={value}
                    values={displayValues}
                    style={style}
                />
            </div>
        );
    }
}
